/* ============================================================
 * services/msauth.js — Login Microsoft (Entra ID / MSAL) via REDIRECT
 * Fluxo de redirecionamento (não usa popup → evita travas/bloqueios).
 * Devolve o ID token para o backend validar e autorizar pela tabela
 * `usuarios`. O client secret NÃO é usado aqui (SPA + PKCE).
 * ============================================================ */
import { PublicClientApplication } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_AAD_CLIENT_ID;
const tenantId = import.meta.env.VITE_AAD_TENANT_ID;

export const msConfigurado = !!clientId && !!tenantId;

let _msal = null;
let _ready = false;

function msal() {
  if (!_msal) {
    _msal = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin,
      },
      cache: { cacheLocation: 'localStorage' },
    });
  }
  return _msal;
}
async function ensureReady() { if (!_ready) { await msal().initialize(); _ready = true; } }

/* Dispara o login: a página inteira vai para a tela da Microsoft. */
export async function iniciarLoginMicrosoft() {
  await ensureReady();
  await msal().loginRedirect({ scopes: ['User.Read'], prompt: 'select_account' });
}

/* Chamado no carregamento: se voltamos de um login, devolve o ID token. */
export async function processarRedirect() {
  await ensureReady();
  const res = await msal().handleRedirectPromise();
  if (res && res.idToken) {
    msal().setActiveAccount(res.account);
    return { idToken: res.idToken, nome: res.account && res.account.name, email: res.account && res.account.username };
  }
  return null;
}

export async function logoutMicrosoft() {
  try { if (_msal) { await ensureReady(); await msal().clearCache(); } } catch (e) { /* ignore */ }
}
